'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = parseMessage;

var _lodash = require('lodash');

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _MessageFormatter = require('@/libs/MessageFormatter');

var _MessageFormatter2 = _interopRequireDefault(_MessageFormatter);

var _TextFormatting = require('@/helpers/TextFormatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseMessage(message) {
    var formatOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var userList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var emojiList = _state2.default.setting('emojis');

    var blocks = (0, _MessageFormatter2.default)(message, formatOpts);
    var formatedBlocks = blocks.reduce(function (acc, block, i) {
        return acc.concat(processBlock(block, userList, emojiList));
    }, []);

    return formatedBlocks;
}

function processBlock(block, userList, emojiList) {
    var wordsRegex = /\S+/g;

    var wordMatch = void 0;
    var word = void 0;
    var specialMatches = [];

    while ((wordMatch = wordsRegex.exec(block.content)) !== null) {

        word = wordMatch[0];

        var match = matchChannel(word) || matchUrl(word) || matchUser(word, userList) || matchEmoji(word, emojiList);

        if (match) {
            specialMatches.push({
                index: wordMatch.index + match.index,
                match: match.match,
                block: (0, _MessageFormatter.createNewBlock)(match.match, block.styles, match.type, match.meta)
            });
        }
    }

    if (specialMatches.length === 0) {
        return [block];
    }

    return mergeMatches(block, specialMatches);
}

function matchChannel(word) {
    var channelMatch = _TextFormatting.channelRegex.exec(word);


    if (channelMatch === null) {
        return false;
    }

    return {
        index: channelMatch[1].length + channelMatch[2].length,
        match: channelMatch[3],
        type: 'channel',
        meta: {
            channel: channelMatch[3]
        }
    };
}

function matchUrl(word) {
    var urlMatch = _TextFormatting.urlRegex.exec(word);

    if (urlMatch === null) {
        return false;
    }

    var url = urlMatch[0];

    if (url.match(/^javascript:/i)) {
        return false;
    }

    if (url.indexOf('(') === -1 && url[url.length - 1] === ')') {
        url = url.substr(0, url.length - 1);
    }

    var urlText = url;
    if (urlText.match(/^www\./i)) {
        urlText = 'http://' + url;
    }

    return {
        index: urlMatch.index,
        match: url,
        matchText: urlText,
        type: 'url',
        meta: {
            url: urlText
        }
    };
}

function matchUser(word, userList) {
    if (!userList) {
        return false;
    }

    var user = null;
    var punc = ',.!:;-+)]?¿\\/<>@';
    var hasProp = Object.prototype.hasOwnProperty;
    var nickIdx = 0;

    var trimWord = (0, _lodash.trim)(word, punc);
    var normWord = trimWord.toLowerCase();

    if (hasProp.call(userList, normWord)) {
        user = userList[normWord];
        nickIdx = word.indexOf(trimWord);
    } else {
        return false;
    }

    return {
        index: nickIdx,
        match: trimWord,
        type: 'user',
        meta: {
            user: trimWord,
            colour: user.colour
        }
    };
}

function matchEmoji(word, emojiList) {
    if (emojiList.hasOwnProperty && !emojiList.hasOwnProperty(word)) {
        return false;
    }

    return {
        index: 0,
        match: word,
        type: 'emoji',
        meta: {
            emoji: emojiList[word]
        }
    };
}

function mergeMatches(block, specialMatches) {
    var resultBlocks = [];
    var lastProcessedIndex = 0;

    specialMatches.forEach(function (specialMatch, index) {
        var beforeMatchContent = block.content.substr(lastProcessedIndex, specialMatch.index - lastProcessedIndex);

        if (beforeMatchContent) {
            resultBlocks.push({
                content: beforeMatchContent,
                styles: (0, _extends3.default)({}, block.styles),
                containsContent: !!beforeMatchContent
            });
        }

        resultBlocks.push(specialMatch.block);

        lastProcessedIndex = specialMatch.index + specialMatch.match.length;
    });

    if (lastProcessedIndex < block.content.length) {
        resultBlocks.push({
            content: block.content.substr(lastProcessedIndex),
            styles: (0, _extends3.default)({}, block.styles),
            containsContent: !!block.content.substr(lastProcessedIndex)
        });
    }

    return resultBlocks;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["MessageParser"]
window._kiwi_exports.libs.MessageParser = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/MessageParser.js
// module id = wXH7
// module chunks = 1